import {detailsPageDataHooks as DH} from '@wix/wix-events-data-hooks'
import React from 'react'
import {useSettings} from '../../../../../../../commons/hooks/use-settings'
import settingsParams from '../../../../../settingsParams'
import {Subtitle} from '../../../subtitle/subtitle'

export const Header = () => {
  const {get} = useSettings()
  const ticketsTitleText = get(settingsParams.ticketsTitleText)

  return <Subtitle dataHook={DH.subtitleTickets} text={ticketsTitleText} compact />
}
